"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAGE_TYPES = {
    home: "home",
    explore: "explore",
    tribute: "tribute",
    default: "default"
};
